// using a function to create the mutations for each type of request, since they all use the same mutation options
// if you need to add to these mutations you could add to the object using mutations.name or copy and paste the object from below to create custom mutations

import { requestStatusSync } from "../../../libs/request-status";

/* 
 * @params: state = namespace state, request = updated request
 *
 * finds the index of the request which was updated and splices into namespace requests
**/
const findAndUpdate = (state, updatedRequest) => {
   const requestFound = state.requests.findIndex(request => {
      return request._id === updatedRequest._id;
   })
   state.requests.splice(requestFound, 1, updatedRequest);
}

const createMutations = (requestType) => {
   return {
      SET_ACTIVE(state, data) {
         state.active = data;
      },
      SET_REQUESTS(state, requests) {
         state.requests = requests;
      },
      SET_UNIQUE_SERVICES(state, services) {
         state.uniqueServices = services;
      },
      SET_NAME: (state, form) => {
         state.filters.name = form.name;
      },
      SET_STATUS: (state, form) => {
         state.filters.status = form.status;
      },
      SET_INCOMPLETE_SERVICES: (state, form) => {
         state.filters.incompleteServices = form.incompleteServices;
      },
      SET_DATE_MIN: (state, form) => {
         state.filters.dateMin = form.dateMin;
      },
      SET_DATE_MAX: (state, form) => {
         state.filters.dateMax = form.dateMax;
      },
      SET_SORT: (state, form) => {
         state.filters.sort = form.sort;
      },
      SOCKET_COMP_UPDATE_REQUEST_SERVICE(state, requestService) {
         // trim mutation down to applicable request-type
         if (requestService.request_type === requestType) {
            const updatedRequest = [...state.requests]
               .filter(request => {
                  return request._id === requestService.request_id
               }).map(request => {
                  request.services = [...request.services].map(service => {
                     if (service._id === requestService._id) {
                        return requestService
                     }
                     return service;
                  });
                  return requestStatusSync(request);
               }).shift();

            findAndUpdate(state, updatedRequest);
         }
      },
      SOCKET_COMP_ADD_REQUEST_SERVICE(state, requestService) {
         if (requestService.request_type === requestType) {
            const updatedRequest = [...state.requests]
               .filter(request => {
                  return request._id === requestService.request_id
               }).map(request => {
                  request.services.push(requestService);
                  return requestStatusSync(request);
               })
               .shift();

            findAndUpdate(state, updatedRequest);
         }
      }
   }
}

export default createMutations;